import Phaser from 'phaser';
import { COLORS } from '../config';
import { generateAllSprites, canvasToDataURL } from '../utils/SpriteGenerator';

/**
 * Boot scene - generates sprites and preloads assets
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Loading UI
    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    progressBox.fillRect(width / 2 - 80, height / 2 - 12, 160, 24);

    const loadingText = this.add.text(width / 2, height / 2 - 30, 'Generating sprites...', {
      fontFamily: 'monospace',
      fontSize: '10px',
      color: '#ffffff',
    });
    loadingText.setOrigin(0.5, 0.5);

    // Generate all sprites
    const sprites = generateAllSprites();
    const spriteList = Object.entries(sprites);
    let loaded = 0;

    // Load each sprite as a texture
    spriteList.forEach(([key, canvas]) => {
      const dataUrl = canvasToDataURL(canvas);
      this.textures.addBase64(key, dataUrl);
      loaded++;

      // Update progress
      const progress = loaded / spriteList.length;
      progressBar.clear();
      progressBar.fillStyle(COLORS.PLAYER, 1);
      progressBar.fillRect(width / 2 - 75, height / 2 - 7, 150 * progress, 14);
    });

    // Wait for textures to be ready
    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
    });

    // Trigger load complete
    this.load.start();
  }

  create(): void {
    // Small delay to ensure textures are ready
    this.time.delayedCall(100, () => {
      this.scene.start('MenuScene');
    });
  }
}
